<template>
  <SimpleDictView
    endpoint="warehouse/vehicle-types/"
    :title="$t('settings.titles.vehicleTypes')"
    :add-button="$t('settings.addButtons.vehicleType')"
    :fields="fields"
  />
</template>
<script>
import SimpleDictView from './SimpleDictView.vue'
export default {
  name: 'VehicleTypesView',
  components: { SimpleDictView },
  computed: {
    fields() {
      return [{ key: 'name', label: this.$t('settings.fields.name'), placeholder: this.$t('settings.placeholders.vehicleTypeName') }]
    },
  },
}
</script>
